import { ProviderCoding, JsonDiffReact } from '@enter/core';
import React from 'react';
import * as S from './claim-timeline-table.styles';

interface ICodingDetailProps {
    coding: ProviderCoding;
}

export const CodingDetail: React.FunctionComponent<ICodingDetailProps> = (
    props: ICodingDetailProps,
): React.ReactElement => {
    const { coding } = props;

    let codingNotes = coding.notes;

    // Handle double encoded coding notes
    if (codingNotes) {
        try {
            codingNotes = JSON.parse(codingNotes);
        } catch (e) {
            // Keep original string if not JSON
        }
    }

    return (
        <S.ExpandWrap key={coding.id}>
            <S.ExpandCol>
                <S.ExpandTable expand={true}>
                    <S.ExpandTBody>
                        <S.ExpandTR>
                            <S.ExpandTH>Coding ID</S.ExpandTH>
                            <S.ExpandTD>{coding.id}</S.ExpandTD>
                        </S.ExpandTR>
                        <S.ExpandTR>
                            <S.ExpandTH>Vendor</S.ExpandTH>
                            <S.ExpandTD>{coding.vendor}</S.ExpandTD>
                        </S.ExpandTR>
                        <S.ExpandTR>
                            <S.ExpandTH>Status</S.ExpandTH>
                            <S.ExpandTD>{coding.status}</S.ExpandTD>
                        </S.ExpandTR>
                        {codingNotes && (
                            <S.ExpandTR>
                                <S.ExpandTH>Notes</S.ExpandTH>
                                <S.ExpandTD>
                                    <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word', fontSize: '12px' }}>
                                        {typeof codingNotes === 'string'
                                            ? codingNotes
                                            : JSON.stringify(codingNotes, null, 2)}
                                    </pre>
                                </S.ExpandTD>
                            </S.ExpandTR>
                        )}
                        <S.ExpandTR>
                            <S.ExpandTD colSpan={2}>
                                <S.JsonViewersContainer>
                                    <S.JsonViewerColumn>
                                        <S.JsonViewerLabel>Before</S.JsonViewerLabel>
                                        <S.JsonViewerWrapper>
                                            <pre style={{ fontSize: '12px' }}>
                                                {coding.before ? JSON.stringify(coding.before, null, 4) : ''}
                                            </pre>
                                        </S.JsonViewerWrapper>
                                    </S.JsonViewerColumn>
                                    <S.JsonViewerColumn>
                                        <S.JsonViewerLabel>After</S.JsonViewerLabel>
                                        <S.JsonViewerWrapper>
                                            <pre style={{ fontSize: '12px' }}>
                                                {coding.after ? JSON.stringify(coding.after, null, 4) : ''}
                                            </pre>
                                        </S.JsonViewerWrapper>
                                    </S.JsonViewerColumn>
                                    <S.JsonViewerColumn>
                                        <S.JsonViewerLabel>Diff</S.JsonViewerLabel>
                                        <S.JsonViewerWrapper>
                                            <JsonDiffReact right={coding.after} left={coding.before} show={false} />
                                        </S.JsonViewerWrapper>
                                    </S.JsonViewerColumn>
                                </S.JsonViewersContainer>
                            </S.ExpandTD>
                        </S.ExpandTR>
                    </S.ExpandTBody>
                </S.ExpandTable>
            </S.ExpandCol>
        </S.ExpandWrap>
    );
};
